export const PAYMENT_SYSTEM_TYPE = {
    PAY_PRO: 'paypro',
    PAY_NL: 'paynl',
};